module.exports = {
  array: Array.isArray,
  primitive: function(s) { return typeof s === 'string' || typeof s === 'number'; },
};



//////////////////
// WEBPACK FOOTER
// ./~/snabbdom/is.js
// module id = 10
// module chunks = 0